import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="upload-picture"
export default class extends Controller {
  static targets = ["input", "icon", "placeholder"];
  static values = { attached: Boolean };

  connect() {
    if (this.attachedValue) {
      this.iconTarget.classList.add("fa-check");
      this.placeholderTarget.textContent = "Already Uploaded";
    }
  }

  change() {
    const file = this.inputTarget.files[0];

    if (file) {
      this.placeholderTarget.textContent = file.name;
      this.iconTarget.classList.add("fa-check");
    } else {
      this.iconTarget.classList.remove("fa-check");
    }
  }
}
